import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.ADVERTISER };
const path = "/advertiser"



export const createInvoice = async (value) => {
    return await axiosInstance(options).post(`${path}/invoices/create`, value);
}
export const previewInvoice = async (value) => {
    return await axiosInstance(options).post(`${path}/invoices/preview`, value);
}
export const getInvoiceList = async (value) => {
    return await axiosInstance(options).post(`${path}/invoices/invoice-list`, value);
}

export const getInvoiceDetails = async (id) => {
    return await axiosInstance(options).get(
        `${path}/invoices/invoice-details?o_id=${id}`
    );
};
export const updateInvoiceStatus = async (values) => {
    return await axiosInstance(options).post(
        `${path}/invoices/update-invoice`, values
    );
};










